import { TFunction } from "react-i18next";
import { DynamicFormRefValues } from "../../../../../../../components/dynamicFormRef/types";
import { EvidenceData } from "../../../../../../../hooks/evidences/typyng";
import { sharedAws } from "../../../../../../../service/bucketS3/Storage";
import { BodyQuestionnaire, CommentConfig, OptionBody, QuestionBody, QuestionnaireSectionBody } from "../../../../../../../service/questionarie/bodys";
import { Item } from "../../../../../../../utils/types/generals";
import { OptionActionSavePayload, ReportSignatureData } from "../../../../../components/optionActions/types";
import { convertEvideceArray, getActionPlans, getEvidenceData } from "../../../methods";
import { AnswerElement, QuestionData, SectionData } from "../types";
import { Answer, Question } from "../../../fragments/section/contextProvider/provider/types";
import { Status } from "../../../../../../../utils/enums";

const formatQuestionnaire = async ({ data, isGeneral, dataHeader, t, draft, generalconfig, isSectionConfig }: {
    data: ({
        sectionData?: SectionData | undefined;
        questionList: any[];
        averageSection?: number
    } | null)[]
    draft: boolean
    isGeneral: boolean
    dataHeader?: DynamicFormRefValues
    isSectionConfig?: boolean
    t: TFunction<"translation", undefined>
    generalconfig?: OptionActionSavePayload
}) => {
    let body: BodyQuestionnaire = {
        statusId: draft ? Status.DRAFT : Number(dataHeader?.statusId ?? 1),
        actionPlanByItem: isGeneral ? 0 : 1,
        ...!isSectionConfig && { totalPoints: dataHeader?.totalPoints as number ?? 1 },
        departmentId: (dataHeader?.departments as Item)?.value,
        areaId: (dataHeader?.areas as Item)?.value,
        name: ((dataHeader?.quest_name ?? '') as string),
        description: ((dataHeader?.description ?? '') as string),
        scoreBySection: Boolean(isSectionConfig),
        instruction: ((dataHeader?.instruction ?? '') as string),
        ...(Boolean(generalconfig?.actionPlan) && isGeneral) && { actionPlan: Boolean(generalconfig?.actionPlan) ? getActionPlans({ t, data: generalconfig?.actionPlan as any })?.data : [] },
        ...Boolean(generalconfig?.comment) && { commentConfig: formatCommentConfig({ comment: generalconfig?.comment }) },
        ...Boolean(generalconfig?.reportSignature) && { signConfig: formatSingsConfig({sings:generalconfig?.reportSignature}) },
        questionnaireSections: data.map(section => formatSection({ data: section, t, isSectionConfig }))
    }
    const images = (await sendImages({ sections: body.questionnaireSections }))

    return {
        ...body,
        questionnaireSections: images
    }
}

const formatSection = ({ data, t, isSectionConfig }: {
    data: {
        sectionData?: SectionData;
        questionList: QuestionData[];
        averageSection?: number
    } | null
    t: TFunction<"translation", undefined>
    isSectionConfig?: boolean
}): QuestionnaireSectionBody => {
    const idListOfQuestion = data?.questionList?.map(question => question.question?.id ?? '')
    return {
        description: data?.sectionData?.description ?? '',
        statusId: 1,
        title: data?.sectionData?.sectionName ?? '',
        ...isSectionConfig && { totalPoints: Number(data?.sectionData?.sectionPoints ?? 0) },
        questions: data?.questionList ? data?.questionList.map((question, index) => formatQuestion({ question, questionList: idListOfQuestion, questionIndex: index, t })) : [],
    }
}

const formatQuestion = ({ question, questionList, questionIndex, t }: { t: TFunction<"translation", undefined>; question: QuestionData, questionList?: string[]; questionIndex: number }): QuestionBody => {
    const questionCopy = question.question
    const option = questionCopy?.questionOption?.value
    const config = JSON.parse(question?.question?.config ?? '{}') as OptionActionSavePayload
    const configGeneral = JSON.parse(question?.configGeneral ?? '{}') as OptionActionSavePayload
    const isOptionType = {
        isSimple: option == '1',
        isMultiple: option == '2',
        isFree: option == '3',
        isAffective: option == '4',
        isCatalog: option == '5'
    }
    const isQuestionEvidence = Boolean(config.evidenceData)
    const isMultipleTheConfig = Boolean(question.configGeneral)

    let description = ''
    if (isOptionType.isFree) {
        const answer = question.answer?.[0]?.answer
        description = (answer?.text ?? answer ?? '') as string
    }
    const questionEvidence = convertEvideceArray(config.evidenceData)
    return {
        comments: 0,
        required: 1,
        typeQuestionId: Number(option ?? '1'),
        title: questionCopy?.questionText ?? '',
        description: description,
        evidenceRequire: isOptionType.isCatalog ? 0 : isQuestionEvidence ? 1 : 0,
        evidenceType: isOptionType.isCatalog ? undefined : isQuestionEvidence ? getEvidenceData({ evidenceType: questionEvidence }) : undefined,
        optionGroupId: questionCopy?.questionTemplate?.value ? Number(questionCopy?.questionTemplate?.value) : undefined,
        ...questionCopy?.helpText && { textHelp: questionCopy?.helpText ?? null },
        options: isOptionType.isCatalog ?
            [formatOptionCatalog({ t, score:Number(questionCopy?.valueQuestion), generalEvidence: config })]
        : 
            question.answer?.map((answer) => formatOptions({ answer, questionList, isOptionType, questionIndex, isMultipleTheConfig, generalEvidence: configGeneral, t })) ?? []
    }
}

const formatOptions = ({ answer, questionList, questionIndex, t, isMultipleTheConfig, generalEvidence, isOptionType }:
    {
        answer: AnswerElement,
        isOptionType: {
            isSimple: boolean;
            isMultiple: boolean;
            isFree: boolean;
            isAffective: boolean;
        }
        t: TFunction<"translation", undefined>; questionList?: string[]; questionIndex: number; isMultipleTheConfig: boolean; generalEvidence?: OptionActionSavePayload
    }): OptionBody => {
    const action = answer.action
    const config = isMultipleTheConfig ? generalEvidence : JSON.parse(answer.config ?? '{}') as OptionActionSavePayload
    const existActionPlan = Boolean(config?.actionPlan)
    const existReportFolio = Boolean(config?.reportFolio)
    const existEvidence = config?.evidenceData
    let step: null | string = null
    if (action && questionList) {
        const findQuestionIndex = questionList?.findIndex(question => question == action.value)
        const substract = Number(findQuestionIndex) - Number(questionIndex)
        if (substract >= 2) {
            step = String(findQuestionIndex)
        }
    }

    const isMultipleAndHaveActiveTheCnfig = (isOptionType.isMultiple && Boolean(answer?.activeReeportFolio))

    const answerEvidence = convertEvideceArray(config?.evidenceData)
    const folioEvidence = convertEvideceArray(config?.reportFolio?.evidence?.evidencesData)
    const answerText = (answer.answer?.text ?? answer.answer)
    return {
        score: Number(answer?.value ?? '0'),
        notApplicable: Boolean(answer?.notApplicable),
        actionPlanRequire: existActionPlan ? 1 : 0,
        evidenceRequire: existEvidence ? 1 : 0,
        actionPlan: ((existActionPlan) && (!isOptionType.isMultiple || isMultipleAndHaveActiveTheCnfig)) ? getActionPlans({ t, data: config?.actionPlan as any })?.data : undefined,
        correctOption: Boolean(answer?.switchOption),
        description: typeof answerText == 'string' ? answerText : '',
        evidenceType: ((existEvidence || isMultipleTheConfig) && (!isOptionType.isMultiple || isMultipleAndHaveActiveTheCnfig)) ? getEvidenceData({ evidenceType: answerEvidence }) : undefined,
        iconUrl: answer.answer?.file ?? '',
        stepId: step,
        ...isMultipleAndHaveActiveTheCnfig && {
            recurrence: !!config?.reincidence,
            amountRecurrenceUser: config?.reincidence?.block ? Number(config?.reincidence?.block) :  null,
            answersAmountRecurrence: config?.reincidence?.reincidence ? Number(config?.reincidence?.reincidence) : null,
        },
        ...!isOptionType.isMultiple && {
            recurrence: !!config?.reincidence,
            amountRecurrenceUser: config?.reincidence?.block ? Number(config?.reincidence?.block) :  null,
            answersAmountRecurrence: config?.reincidence?.reincidence ? Number(config?.reincidence?.reincidence) : null,
        },
        configReportFolio: ((existReportFolio) && (!isOptionType.isMultiple || isMultipleAndHaveActiveTheCnfig)) ? {
            isAreaRequired: true,
            isDepartmentRequired: true,
            askForArea: true,
            askForDepartment: true,
            // isRequired: !!config?.reportFolio?.default?.reportFolioIsRequired,
            configActionPlanReportFolioEvidenceTypes: getEvidenceData({ evidenceType: folioEvidence }),
            enableRatingQuestion: !!config?.reportFolio?.default?.enable,
            isRatingQuestionRequired: !!config?.reportFolio?.default?.required,
            ...!!config?.reportFolio?.default?.enable && { ratingQuestion: (config?.reportFolio?.default?.description as string) },
            ...!!config?.reportFolio?.default?.maxRejectsAmount && { maxRejects: (config?.reportFolio?.default?.maxRejectsAmount as string) },
            ...!!config?.reportFolio?.default?.maxFoliosAmount && { max: (config?.reportFolio?.default?.maxFoliosAmount as string) }
        } : null,
    }
}

const formatOptionCatalog = ({  t, generalEvidence, score }:
    { 
        generalEvidence?: OptionActionSavePayload; score:number;  t: TFunction<"translation", undefined>; 
    }): OptionBody => {
    const config = generalEvidence
    const existActionPlan = Boolean(config?.actionPlan)
    const existReportFolio = Boolean(config?.reportFolio)
    const existEvidence = config?.evidenceData
    const answerEvidence = convertEvideceArray(config?.evidenceData)
    const folioEvidence = convertEvideceArray(config?.reportFolio?.evidence?.evidencesData)

    return {
        score: score,
        notApplicable: false,
        actionPlanRequire: existActionPlan ? 1 : 0,
        evidenceRequire: existEvidence ? 1 : 0,
        actionPlan: existActionPlan ? getActionPlans({ t, data: config?.actionPlan as any })?.data : undefined,
        correctOption: true,
        description: '',
        evidenceType: existEvidence ? getEvidenceData({ evidenceType: answerEvidence }) : undefined,
        iconUrl: null,
        stepId: null,
        configReportFolio: existReportFolio ? {
            isAreaRequired: true,
            isDepartmentRequired: true,
            askForArea: true,
            askForDepartment: true,
            // isRequired: !!config?.reportFolio?.default?.reportFolioIsRequired,
            configActionPlanReportFolioEvidenceTypes: getEvidenceData({ evidenceType: folioEvidence }),
            enableRatingQuestion: !!config?.reportFolio?.default?.enable,
            isRatingQuestionRequired: !!config?.reportFolio?.default?.required,
            ...!!config?.reportFolio?.default?.enable && { ratingQuestion: (config?.reportFolio?.default?.description as string) },
            ...!!config?.reportFolio?.default?.maxRejectsAmount && { maxRejects: (config?.reportFolio?.default?.maxRejectsAmount as string) },
            ...!!config?.reportFolio?.default?.maxFoliosAmount && { max: (config?.reportFolio?.default?.maxFoliosAmount as string) }
        } : null,
    }
}

const sendImages = async ({ sections }: { sections: QuestionnaireSectionBody[] }) => {
    const sectionList = []
    for (const section of sections) {
        const sectionResponse = await listOfSections({ section })
        sectionList.push(sectionResponse)
    }
    return await sectionList
}

const listOfSections = async ({ section }: { section: QuestionnaireSectionBody }) => {
    const questionList = []
    for (const question of section.questions) {
        const questionResponse = await listOfQuestion({ question })
        questionList.push(questionResponse)
    }
    return await { ...section, questions: questionList }
}

const listOfQuestion = async ({ question }: { question: QuestionBody }) => {
    const optionList = []
    for (const options of question?.options) {
        const optinResponse = await listOfOptions({ options })
        optionList.push(optinResponse)
    }
    return await { ...question, options: optionList }
}

const listOfOptions = async ({ options }: { options: OptionBody }) => {
    try {
        const url = (options?.iconUrl as File)?.name ? await sharedAws.uploadAndGetUrl({ file: options.iconUrl as File, name: `${new Date().getTime()}`, otherBucket: process.env.REACT_APP_BUCKET_ICON_QUESTIONNARIES }) : options?.iconUrl
        return await { ...options, iconUrl: url }

    } catch (e) {
        return { ...options, iconUrl: typeof options?.iconUrl == 'string' ? options?.iconUrl : "" }
    }
}

const formatCommentConfig = ({ comment }: {
    comment?: {
        evidence: EvidenceData[];
        default?: DynamicFormRefValues | undefined;
    }
}): CommentConfig => {
    const commentEvidence = convertEvideceArray(comment?.evidence)
    return {
        amount: { enable: false, required: false },
        observation: { enable: false, required: false },
        questionnaireCommentEvidenceConfig: getEvidenceData({ evidenceType: commentEvidence }),
        required: Boolean(comment?.default?.comment),
        title: { enable: false, required: false },
    }
}

const formatSingsConfig = ({ sings }: { sings?: ReportSignatureData[] }) => {
    return  sings?.map(sign => ({
        description: sign.description,
        required: sign.requeired,
        comment: sign.addComment,
        requiredComment: sign.reqiredComment 
    }))
}

const removeActionPlan = ({ question, questionIdList, questionIndex }: { question: Question; questionIdList: { id: string | number }[]; questionIndex: number }): Question => {
    return {
        ...question,
        answer: question.answer?.map(answer => removeActionPlanOfAnswer({ answer, questionIdList, questionIndex }))
    }
}
const removeActionPlanOfAnswer = ({ answer, questionIdList, questionIndex }: { answer: Answer; questionIdList: { id: string | number }[]; questionIndex: number; }): Answer => {
    if (answer.action) {
        let step: null | string = null
        const findQuestionIndex = questionIdList.findIndex(question => question.id == answer.action?.value)

        const substract = Number(findQuestionIndex) - Number(questionIndex)
        if (substract >= 2) {
            step = String(findQuestionIndex)
        }

        if (!step) { answer.action = undefined }
    }
    return answer
}
export { formatQuestionnaire, removeActionPlan }